import { useCallback, useEffect, useRef, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import Seo from '../../components/shared/Seo';



const RETRY_HINT_MS = 4000;



const submitReturnForm = (browserFormPostUrl, encodedCxml) => {

    const form = document.createElement('form');

    form.method = 'POST';

    form.action = browserFormPostUrl;

    form.style.display = 'none';



    const input = document.createElement('input');

    input.type = 'hidden';

    input.name = 'cxml-urlencoded';

    input.value = encodedCxml;

    form.appendChild(input);



    document.body.appendChild(form);

    form.submit();

};



//-- Intermediate handoff after a successful cart-return API call. Auto-submits the

//-- PunchOutOrderMessage to Coupa's BrowserFormPost URL (top-level navigation). Manual

//-- retry re-submits the same form only — it does not call the return API again.

const PunchOutReturning = () => {

    const location = useLocation();

    const { browserFormPostUrl, encodedCxml, provider } = location.state || {};

    const hasPayload = Boolean(browserFormPostUrl && encodedCxml);



    const [submitError, setSubmitError] = useState('');

    const [showRetry, setShowRetry] = useState(false);

    const hasAutoSubmittedRef = useRef(false);



    const providerLabel = provider || 'Coupa';



    const runSubmit = useCallback(() => {

        if (!browserFormPostUrl || !encodedCxml) {

            return;

        }

        try {

            setSubmitError('');

            submitReturnForm(browserFormPostUrl, encodedCxml);

        } catch (err) {

            setSubmitError('We could not return your cart automatically. Please try again.');

            setShowRetry(true);

        }

    }, [browserFormPostUrl, encodedCxml]);



    useEffect(() => {

        if (!hasPayload || hasAutoSubmittedRef.current) {

            return;

        }

        hasAutoSubmittedRef.current = true;

        runSubmit();



        //-- If the browser is still on this page after a few seconds, offer a manual retry

        //-- (popup blockers / CSP / unexpected form failures leave the buyer here).

        const timer = window.setTimeout(() => setShowRetry(true), RETRY_HINT_MS);

        return () => window.clearTimeout(timer);

    }, [hasPayload, runSubmit]);



    if (!hasPayload) {

        return (

            <>

                <Seo title="PunchOut" description="Return cart to procurement system" keywords="PunchOut" />

                <section className="about-area ptb-60">

                    <div className="container">

                        <div className="row align-items-center">

                            <div className="col-lg-12 col-md-12 text-center">

                                <p role="alert">

                                    Your cart return data is no longer available. Please return to your cart

                                    and try again, or restart shopping from your procurement system.

                                </p>

                                <Link to="/cart" className="btn btn-primary mt-3">Return to cart</Link>

                            </div>

                        </div>

                    </div>

                </section>

            </>

        );

    }



    return (

        <>

            <Seo title="Returning Cart" description="Returning cart to procurement system" keywords="PunchOut" />

            <section className="about-area ptb-60">

                <div className="container">

                    <div className="row align-items-center">

                        <div className="col-lg-12 col-md-12 text-center">

                            {!submitError

                                ? (

                                    <>

                                        <div

                                            className="spinner-border text-primary mb-3"

                                            role="status"

                                            aria-label="Loading"

                                        >

                                            <span className="sr-only">Loading...</span>

                                        </div>

                                        <p>Returning your cart to {providerLabel}...</p>

                                    </>

                                )

                                : <p className="text-danger" role="alert">{submitError}</p>}

                            {showRetry

                                ? (

                                    <button

                                        type="button"

                                        className="btn btn-primary mt-3"

                                        onClick={runSubmit}

                                    >

                                        Retry return to {providerLabel}

                                    </button>

                                )

                                : null}

                        </div>

                    </div>

                </div>

            </section>

        </>

    );

};



export default PunchOutReturning;


